import { Box } from "@material-ui/core";
import React from "react";

import type { FC, SVGAttributes } from "react";

export const StreamingCommentHidden: React.FC<{
  THEOPlayerElementHeight: number;
}> = ({ THEOPlayerElementHeight }) => {
  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      height={THEOPlayerElementHeight}
    >
      <CommentHiddenIcon width={48} height={48} />
    </Box>
  );
};

const CommentHiddenIcon: FC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 48 48" {...props}>
      <g clipPath="url(#clip0_3694_7361)">
        <path
          d="M42.2477 43.8913C41.7959 43.8913 41.352 43.7204 41.0093 43.3786L4.51402 6.98252C3.82866 6.29903 3.82866 5.19612 4.51402 4.51262C5.19938 3.82913 6.3053 3.82913 6.99065 4.51262L43.486 40.9087C44.1713 41.5922 44.1713 42.6951 43.486 43.3786C43.1433 43.7204 42.6994 43.8913 42.2477 43.8913Z"
          fill="#5C5C5C"
        />
        <path
          d="M39.6462 7.54883H10.4095C8.40014 7.54883 6.75684 9.18766 6.75684 11.1915V43.9915L14.0621 36.7061H39.6462C41.6556 36.7061 43.2989 35.0673 43.2989 33.0634V11.1993C43.2989 9.19543 41.6556 7.55659 39.6462 7.55659V7.54883ZM39.6462 33.0634H14.0621L10.4095 36.7061V11.1993H39.6462V33.0634Z"
          fill="#5C5C5C"
        />
      </g>
      <defs>
        <clipPath id="clip0_3694_7361">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
